import { Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { MessageContainer, StyledIcon, StyledTitle } from "./StyledComponents";

export type MessageProps = {
    showTitle?: boolean;
    text: string;
};

/**
 * Import Channel modal content message
 */
const Message = (props: MessageProps) => {
    const { showTitle = false, text } = props;

    return (
        <MessageContainer className="kms-ds-import-channel-action-message">
            <StyledIcon />
            {showTitle && <StyledTitle variant={"h3"}>{translate("Importing started!")}</StyledTitle>}
            <Typography variant={"body1"}>{text}</Typography>
        </MessageContainer>
    );
};

export default Message;
